import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Search, Plus, Trash2, Edit2, KeyRound, X, Check, Download, FileText } from 'lucide-react';

const PERFIL_COLOR = { 1:'#f6c90e', 2:'#60a5fa', 3:'#a78bfa', 4:'#fb923c', 5:'#4ade80', 6:'#2dd4bf', 7:'#f97316' };
const PERFIL_LABEL = { 1:'Chefe', 2:'Vendedor', 3:'Gerente Comercial', 4:'Pré Venda', 5:'Pós Venda', 6:'Engenheiro', 7:'Instalador' };
// Ordem personalizada do dropdown (array para preservar a sequência)
const PERFIL_OPTIONS = [
  { value: 1, label: 'Chefe' },
  { value: 3, label: 'Gerente Comercial' },
  { value: 2, label: 'Vendedor' },
  { value: 4, label: 'Pré Venda' },
  { value: 5, label: 'Pós Venda' },
  { value: 6, label: 'Engenheiro' },
  { value: 7, label: 'Instalador' },
];

const S = {
  heading:     { fontSize:22, fontWeight:700, color:'#f6c90e', marginBottom:4 },
  sub:         { fontSize:13, color:'#475569', marginBottom:20 },
  topRow:      { display:'flex', alignItems:'center', gap:12, marginBottom:16, flexWrap:'wrap' },
  searchBox:   { display:'flex', alignItems:'center', gap:8, background:'#0e1420', border:'1px solid #1a2035', borderRadius:8, padding:'8px 12px', flex:1, minWidth:200 },
  searchInput: { background:'none', border:'none', color:'#e2e8f0', fontSize:13, outline:'none', flex:1 },
  btnPrimary:  { display:'flex', alignItems:'center', gap:6, padding:'8px 16px', borderRadius:8, background:'rgba(246,201,14,0.15)', color:'#f6c90e', fontSize:13, cursor:'pointer', border:'1px solid rgba(246,201,14,0.3)', fontWeight:600 },
  btnDanger:   { display:'flex', alignItems:'center', gap:6, padding:'8px 14px', borderRadius:8, background:'rgba(248,113,113,0.1)', color:'#f87171', fontSize:13, cursor:'pointer', border:'1px solid rgba(248,113,113,0.3)' },
  btnSecondary:{ display:'flex', alignItems:'center', gap:6, padding:'8px 14px', borderRadius:8, background:'rgba(96,165,250,0.1)', color:'#60a5fa', fontSize:13, cursor:'pointer', border:'1px solid rgba(96,165,250,0.3)' },
  th:          { padding:'10px 14px', textAlign:'left', fontSize:11, color:'#475569', textTransform:'uppercase', letterSpacing:1, borderBottom:'1px solid #1a2035' },
  td:          { padding:'11px 14px', fontSize:13, color:'#cbd5e1', borderBottom:'1px solid #0f1117' },
  tag:         (c) => ({ padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600, background:`${c}22`, color:c, border:`1px solid ${c}44`, whiteSpace:'nowrap' }),
  iconBtn:     (c) => ({ background:'none', border:'none', cursor:'pointer', color:c, padding:'4px', borderRadius:4, display:'flex', alignItems:'center' }),
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal:       { background:'#0e1420', border:'1px solid #1a2035', borderRadius:16, padding:28, width:480, maxWidth:'90vw', maxHeight:'90vh', overflowY:'auto' },
  modalTitle:  { fontSize:17, fontWeight:700, color:'#f6c90e' },
  label:       { fontSize:11, color:'#64748b', textTransform:'uppercase', letterSpacing:1, marginBottom:4, display:'block' },
  input:       { width:'100%', background:'#080c14', border:'1px solid #1a2035', borderRadius:8, padding:'9px 12px', color:'#e2e8f0', fontSize:13, outline:'none', boxSizing:'border-box' },
  select:      { width:'100%', background:'#080c14', border:'1px solid #1a2035', borderRadius:8, padding:'9px 12px', color:'#e2e8f0', fontSize:13, outline:'none', boxSizing:'border-box' },
  formRow:     { marginBottom:14 },
  modalBtns:   { display:'flex', gap:10, justifyContent:'flex-end', marginTop:22 },
  err:         { background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:13, marginBottom:14 },
  ok:          { background:'rgba(74,222,128,0.1)', border:'1px solid rgba(74,222,128,0.3)', borderRadius:8, padding:'10px 14px', color:'#4ade80', fontSize:13, marginBottom:14 },
};

function Modal({ title, onClose, children }) {
  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
          <div style={S.modalTitle}>{title}</div>
          <button style={S.iconBtn('#64748b')} onClick={onClose}><X size={18} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

const EMPTY_FORM = { nome:'', username:'', email:'', perfil_acesso:2, telefone:'', password:'' };

export default function Funcionarios() {
  const [users, setUsers]           = useState([]);
  const [search, setSearch]         = useState('');
  const [loading, setLoading]       = useState(true);
  const [modal, setModal]           = useState(null); // null | 'create' | 'edit' | 'senha'
  const [form, setForm]             = useState(EMPTY_FORM);
  const [editId, setEditId]         = useState(null);
  const [err, setErr]               = useState('');
  const [ok, setOk]                 = useState('');
  const [saving, setSaving]         = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [logsModal, setLogsModal]   = useState(false);
  const [logsDatas, setLogsDatas]   = useState({ inicio: '', fim: '' });
  const [logsLoading, setLogsLoading] = useState(false);

  const load = () => {
    setLoading(true);
    setErr('');
    api.get('/admin/usuarios/')
      .then(r => setUsers(r.data))
      .catch(e => setErr(e.response?.data?.error || 'Erro ao carregar funcionários.'))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const filtered = users.filter(u =>
    u.nome?.toLowerCase().includes(search.toLowerCase()) ||
    u.username?.toLowerCase().includes(search.toLowerCase()) ||
    u.cargo?.toLowerCase().includes(search.toLowerCase()) ||
    (u.perfil_label || '').toLowerCase().includes(search.toLowerCase())
  );

  const openCreate = () => { setForm(EMPTY_FORM); setErr(''); setOk(''); setModal('create'); };
  const openEdit   = (u)  => { setEditId(u.id); setForm({ nome:u.nome, username:u.username, email:u.email||'', perfil_acesso:u.perfil_acesso, telefone:u.telefone||'', password:'', new_username:u.username, percentual_comissao:u.percentual_comissao??'', meta_mensal:u.meta_mensal??'' }); setErr(''); setOk(''); setModal('edit'); };
  const openSenha  = (u)  => { setEditId(u.id); setForm({ ...EMPTY_FORM, password:'' }); setErr(''); setOk(''); setModal('senha'); };

  const handleDelete = async (u) => {
    if (!window.confirm(`Tem certeza que deseja excluir "${u.nome}"?\nEsta ação não pode ser desfeita.`)) return;
    try {
      await api.delete(`/admin/usuarios/${u.id}/`);
      setOk('Usuário excluído com sucesso.');
      load();
    } catch (e) {
      alert(e.response?.data?.error || 'Erro ao excluir usuário.');
    }
  };

  const handleSubmit = async () => {
    setErr(''); setSaving(true);
    try {
      if (modal === 'create') {
        if (!form.username || !form.password || !form.nome) {
          setErr('Nome, usuário e senha são obrigatórios.'); setSaving(false); return;
        }
        await api.post('/admin/usuarios/', form);
        setOk('Usuário criado com sucesso!');
      } else if (modal === 'edit') {
        const payload = { nome:form.nome, email:form.email, perfil_acesso:Number(form.perfil_acesso), telefone:form.telefone, username:form.new_username };
        if ([2, 3].includes(Number(form.perfil_acesso))) {
          if (form.percentual_comissao !== '') payload.percentual_comissao = parseFloat(form.percentual_comissao) || 0;
          if (form.meta_mensal !== '') payload.meta_mensal = parseFloat(form.meta_mensal) || null;
        }
        await api.patch(`/admin/usuarios/${editId}/`, payload);
        setOk('Usuário atualizado!');
      } else if (modal === 'senha') {
        if (!form.password) { setErr('Digite a nova senha.'); setSaving(false); return; }
        await api.patch(`/admin/usuarios/${editId}/`, { password: form.password });
        setOk('Senha alterada com sucesso!');
      }
      load();
      setTimeout(() => { setModal(null); setOk(''); }, 1400);
    } catch (e) {
      setErr(e.response?.data?.error || 'Erro ao salvar. Verifique os dados.');
    } finally { setSaving(false); }
  };

  const handleDownloadPdf = async () => {
    setPdfLoading(true);
    try {
      const resp = await api.get('/auth/credenciais-pdf/', { responseType: 'blob' });
      const url  = window.URL.createObjectURL(new Blob([resp.data], { type:'application/pdf' }));
      const a    = document.createElement('a');
      a.href = url; a.download = 'credenciais_crm_solar.pdf'; a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert('Erro ao gerar PDF de credenciais.');
    } finally { setPdfLoading(false); }
  };

  const f = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const handleDownloadLogs = async () => {
    setLogsLoading(true);
    try {
      const params = {};
      if (logsDatas.inicio) params.data_inicio = logsDatas.inicio;
      if (logsDatas.fim)    params.data_fim    = logsDatas.fim;
      const resp = await api.get('/admin/logs/pdf/', { params, responseType: 'blob' });
      const inicio = logsDatas.inicio || 'inicio';
      const fim    = logsDatas.fim    || 'fim';
      const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
      const a   = document.createElement('a');
      a.href = url;
      a.download = `logs_${inicio}_${fim}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
      setLogsModal(false);
    } catch (e) {
      alert('Erro ao gerar relatório de logs.');
    } finally { setLogsLoading(false); }
  };

  return (
    <div>
      <div style={S.heading}>Funcionários</div>
      <div style={S.sub}>Gerencie usuários — criar, editar, alterar senhas e excluir contas</div>

      <div style={S.topRow}>
        <div style={S.searchBox}>
          <Search size={14} color="#475569" />
          <input style={S.searchInput} placeholder="Buscar por nome, usuário ou cargo..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <button style={S.btnPrimary} onClick={openCreate}>
          <Plus size={15} /> Novo Funcionário
        </button>
        <button style={{ ...S.btnSecondary, opacity: pdfLoading ? 0.6 : 1 }} onClick={handleDownloadPdf} disabled={pdfLoading}>
          <Download size={15} /> {pdfLoading ? 'Gerando...' : 'PDF Credenciais'}
        </button>
        <button style={{ display:'flex', alignItems:'center', gap:6, padding:'8px 14px', borderRadius:8, background:'rgba(251,146,60,0.1)', color:'#fb923c', fontSize:13, cursor:'pointer', border:'1px solid rgba(251,146,60,0.3)' }} onClick={() => { setLogsDatas({ inicio:'', fim:'' }); setLogsModal(true); }}>
          <FileText size={15} /> Relatório de Logs
        </button>
      </div>

      {ok && !modal && (
        <div style={S.ok}><Check size={14} style={{ display:'inline', marginRight:6 }} />{ok}</div>
      )}

      {err && !modal && (
        <div style={S.err}>{err}</div>
      )}

      <div style={{ background:'#0e1420', border:'1px solid #1a2035', borderRadius:12, overflowX:'auto', overflowY:'auto', maxHeight:400 }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr>
              <th style={S.th}>Nome</th>
              <th style={S.th}>Usuário</th>
              <th style={S.th}>Perfil</th>
              <th style={S.th}>Telefone</th>
              <th style={S.th}>E-mail</th>
              <th style={S.th}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={6} style={{ ...S.td, textAlign:'center', color:'#475569', padding:32 }}>Carregando...</td></tr>
            )}
            {!loading && filtered.map(u => {
              const color = PERFIL_COLOR[u.perfil_acesso] || '#64748b';
              return (
                <tr key={u.id}
                  onMouseEnter={e => e.currentTarget.style.background='#111827'}
                  onMouseLeave={e => e.currentTarget.style.background=''}>
                  <td style={S.td}><strong style={{ color:'#e2e8f0' }}>{u.nome}</strong></td>
                  <td style={S.td}><code style={{ color:'#94a3b8', fontSize:12 }}>{u.username}</code></td>
                  <td style={S.td}><span style={S.tag(color)}>{u.perfil_label || PERFIL_LABEL[u.perfil_acesso]}</span></td>
                  <td style={S.td}>{u.telefone || '—'}</td>
                  <td style={S.td}>{u.email || '—'}</td>
                  <td style={S.td}>
                    <div style={{ display:'flex', gap:4 }}>
                      <button style={S.iconBtn('#60a5fa')} title="Editar dados" onClick={() => openEdit(u)}><Edit2 size={14} /></button>
                      <button style={S.iconBtn('#c084fc')} title="Alterar senha" onClick={() => openSenha(u)}><KeyRound size={14} /></button>
                      <button style={S.iconBtn('#f87171')} title="Excluir usuário" onClick={() => handleDelete(u)}><Trash2 size={14} /></button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {!loading && filtered.length === 0 && (
              <tr><td colSpan={6} style={{ ...S.td, textAlign:'center', color:'#475569', padding:32 }}>Nenhum funcionário encontrado</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <div style={{ marginTop:10, fontSize:11, color:'#475569' }}>{users.length} funcionário(s) cadastrado(s)</div>

      {/* ── Modal Criar ── */}
      {modal === 'create' && (
        <Modal title="➕ Novo Funcionário" onClose={() => setModal(null)}>
          {err && <div style={S.err}>{err}</div>}
          {ok  && <div style={S.ok}>{ok}</div>}
          <div style={S.formRow}><label style={S.label}>Nome completo *</label><input style={S.input} placeholder="Ex: João Silva" value={form.nome} onChange={f('nome')} /></div>
          <div style={S.formRow}><label style={S.label}>Usuário (login) *</label><input style={S.input} placeholder="Ex: joao.silva" value={form.username} onChange={f('username')} /></div>
          <div style={S.formRow}><label style={S.label}>Senha *</label><input style={S.input} type="password" placeholder="Mínimo 6 caracteres" value={form.password} onChange={f('password')} /></div>
          <div style={S.formRow}><label style={S.label}>E-mail</label><input style={S.input} type="email" placeholder="email@solar.com" value={form.email} onChange={f('email')} /></div>

          <div style={S.formRow}><label style={S.label}>Perfil de Acesso *</label>
            <select style={S.select} value={form.perfil_acesso} onChange={f('perfil_acesso')}>
              {PERFIL_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
          <div style={S.formRow}><label style={S.label}>Telefone</label><input style={S.input} placeholder="(31) 99999-9999" value={form.telefone} onChange={f('telefone')} /></div>
          <div style={S.modalBtns}>
            <button style={S.btnDanger} onClick={() => setModal(null)}>Cancelar</button>
            <button style={{ ...S.btnPrimary, opacity: saving ? 0.6 : 1 }} onClick={handleSubmit} disabled={saving}>
              {saving ? 'Criando...' : 'Criar Funcionário'}
            </button>
          </div>
        </Modal>
      )}

      {/* ── Modal Editar ── */}
      {modal === 'edit' && (
        <Modal title="✏️ Editar Funcionário" onClose={() => setModal(null)}>
          {err && <div style={S.err}>{err}</div>}
          {ok  && <div style={S.ok}>{ok}</div>}
          <div style={S.formRow}><label style={S.label}>Nome completo</label><input style={S.input} value={form.nome} onChange={f('nome')} /></div>
          <div style={S.formRow}><label style={S.label}>Usuário (login)</label><input style={S.input} placeholder="Ex: posvenda" value={form.new_username} onChange={f('new_username')} /></div>
          <div style={S.formRow}><label style={S.label}>E-mail</label><input style={S.input} type="email" value={form.email} onChange={f('email')} /></div>
          <div style={S.formRow}><label style={S.label}>Perfil de Acesso</label>
            <select style={S.select} value={form.perfil_acesso} onChange={f('perfil_acesso')}>
              {PERFIL_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
          <div style={S.formRow}><label style={S.label}>Telefone</label><input style={S.input} value={form.telefone} onChange={f('telefone')} /></div>
          {[2, 3].includes(Number(form.perfil_acesso)) && (
            <div style={{ ...S.formRow, background:'rgba(74,222,128,0.06)', border:'1px solid rgba(74,222,128,0.2)', borderRadius:10, padding:14 }}>
              <label style={{ ...S.label, color:'#4ade80' }}>Comissão sobre Vendas (%)</label>
              <input
                style={{ ...S.input, borderColor:'rgba(74,222,128,0.3)' }}
                type="number"
                min="0"
                max="100"
                step="0.1"
                placeholder="Ex: 3.5"
                value={form.percentual_comissao}
                onChange={f('percentual_comissao')}
              />
              <div style={{ fontSize:11, color:'#475569', marginTop:4 }}>
                {form.percentual_comissao > 0 && form.percentual_comissao !== ''
                  ? `Exemplo: venda de R$ 30.000 → comissão de R$ ${(30000 * parseFloat(form.percentual_comissao || 0) / 100).toLocaleString('pt-BR', { minimumFractionDigits:2 })}`
                  : 'Deixe 0 se não recebe comissão'}
              </div>
              <div style={{ marginTop:12 }}>
                <label style={{ ...S.label, color:'#f6c90e' }}>Meta Mensal de Vendas (R$)</label>
                <input
                  style={{ ...S.input, borderColor:'rgba(246,201,14,0.3)' }}
                  type="number"
                  min="0"
                  step="100"
                  placeholder="Ex: 50000"
                  value={form.meta_mensal}
                  onChange={f('meta_mensal')}
                />
                <div style={{ fontSize:11, color:'#475569', marginTop:4 }}>
                  {form.meta_mensal > 0 ? `Meta: R$ ${parseFloat(form.meta_mensal).toLocaleString('pt-BR', { minimumFractionDigits:2 })} / mês` : 'Deixe em branco se não possui meta'}
                </div>
              </div>
            </div>
          )}
          <div style={S.modalBtns}>
            <button style={S.btnDanger} onClick={() => setModal(null)}>Cancelar</button>
            <button style={{ ...S.btnPrimary, opacity: saving ? 0.6 : 1 }} onClick={handleSubmit} disabled={saving}>
              {saving ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </div>
        </Modal>
      )}

      {/* ── Modal Senha ── */}
      {modal === 'senha' && (
        <Modal title="🔑 Alterar Senha" onClose={() => setModal(null)}>
          {err && <div style={S.err}>{err}</div>}
          {ok  && <div style={S.ok}>{ok}</div>}
          <div style={S.formRow}>
            <label style={S.label}>Nova Senha</label>
            <input style={S.input} type="password" placeholder="Digite a nova senha" value={form.password} onChange={f('password')} />
          </div>
          <div style={{ fontSize:12, color:'#475569', marginBottom:14 }}>
            A nova senha entra em vigor imediatamente. O usuário precisará fazer login novamente.
          </div>
          <div style={S.modalBtns}>
            <button style={S.btnDanger} onClick={() => setModal(null)}>Cancelar</button>
            <button style={{ ...S.btnPrimary, opacity: saving ? 0.6 : 1 }} onClick={handleSubmit} disabled={saving}>
              {saving ? 'Alterando...' : 'Alterar Senha'}
            </button>
          </div>
        </Modal>
      )}

      {/* ── Modal Relatório de Logs ── */}
      {logsModal && (
        <Modal title="📋 Relatório de Logs de Acesso" onClose={() => setLogsModal(false)}>
          <div style={{ fontSize:13, color:'#64748b', marginBottom:18 }}>
            Selecione o intervalo de datas para gerar o PDF com os registros de acesso ao sistema.
            Deixe em branco para incluir todo o período.
          </div>
          <div style={S.formRow}>
            <label style={S.label}>Data Inicial</label>
            <input
              style={S.input}
              type="date"
              value={logsDatas.inicio}
              onChange={e => setLogsDatas(p => ({ ...p, inicio: e.target.value }))}
            />
          </div>
          <div style={S.formRow}>
            <label style={S.label}>Data Final</label>
            <input
              style={S.input}
              type="date"
              value={logsDatas.fim}
              onChange={e => setLogsDatas(p => ({ ...p, fim: e.target.value }))}
            />
          </div>
          <div style={{ fontSize:11, color:'#475569', marginBottom:18, background:'rgba(251,146,60,0.07)', border:'1px solid rgba(251,146,60,0.2)', borderRadius:8, padding:'10px 12px' }}>
            O PDF incluirá: login/logout, falhas de autenticação, criação e exclusão de funcionários, alterações de senha e uploads inválidos.
          </div>
          <div style={S.modalBtns}>
            <button style={S.btnDanger} onClick={() => setLogsModal(false)}>Cancelar</button>
            <button
              style={{ display:'flex', alignItems:'center', gap:6, padding:'9px 18px', borderRadius:8, background:'rgba(251,146,60,0.15)', color:'#fb923c', fontSize:13, cursor: logsLoading ? 'not-allowed' : 'pointer', border:'1px solid rgba(251,146,60,0.3)', fontWeight:600, opacity: logsLoading ? 0.6 : 1 }}
              onClick={handleDownloadLogs}
              disabled={logsLoading}
            >
              <Download size={14} /> {logsLoading ? 'Gerando PDF...' : 'Gerar e Baixar PDF'}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}
